export default __webpack_public_path__ + "static/media/placeholderSocial.dc288cca.png";